import { IUnitsInformation } from "../components/UnitsInformation";
import { getImageSet } from "../components/UnitsInformation/subComponents/Image";
import { IUnitImages } from "../components/UnitsInformation/type";

export const getPrimaryImage = (images: IUnitImages | undefined, unitInformation: IUnitsInformation) => {
  const customImages = images?.customImages ?? [];
  const defaultImages = images?.defaultImages ?? [];
  const FALLBACK = "https://placehold.co/150";

  // If no custom images → first default
  if (customImages.length === 0) {
    const firstDefault = defaultImages[0];

    const defaultImagesOfUT = getImageSet({
      size: {
        length: unitInformation.size.length,
        width: unitInformation.size.width,
        height: unitInformation.size.height || 0,
      },
      category: unitInformation.category,
      unitType: unitInformation.unitType,
      amenities: unitInformation.amenities,
    } as IUnitsInformation)
 
    return defaultImagesOfUT[0]?.url || firstDefault?.key || FALLBACK;
  }

  // Custom exists → find isPrimary === true
  const primaryCustom = customImages.find(img => img.isPrimary);
  if (primaryCustom) return primaryCustom.preSignedUrl || primaryCustom.key;

  // No primary → use first custom
  const firstCustom = customImages[0];
  return firstCustom?.preSignedUrl || firstCustom?.key || FALLBACK;
};


export const getAllImages = (images: IUnitImages | undefined, unitInformation: IUnitsInformation) => {
  const customImages = images?.customImages ?? [];
  //const defaultImages = images?.defaultImages ?? [];
  const FALLBACK = "https://placehold.co/150";

  // If no customImages → return defaultImages
  if (customImages.length === 0) {
    /* if (defaultImages.length > 0) {
      return defaultImages.map(img => img.preSignedUrl || img.key);
    }
    return [FALLBACK]; */

    const defaultImagesOfUT = getImageSet({
      size: {
        length: unitInformation.size.length,
        width: unitInformation.size.width,
        height: unitInformation.size.height || 0,
      },
      category: unitInformation.category,
      unitType: unitInformation.unitType,
      amenities: unitInformation.amenities,
    } as IUnitsInformation);

    return defaultImagesOfUT?.map(defImage => defImage.url) || [FALLBACK];    
  }

  // Custom images → order by sequenceNo
  const sortedCustom = [...customImages].sort(
    (a, b) => (a.sequenceNo ?? Number.MAX_SAFE_INTEGER)
            - (b.sequenceNo ?? Number.MAX_SAFE_INTEGER)
  );
  const imageUrls = sortedCustom.map(img => img.preSignedUrl || img.key);

  return imageUrls.length ? imageUrls : [FALLBACK];
};
